import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function Login() {
    const { login } = useAuth();
    const nav = useNavigate();
    const [params] = useSearchParams();
    const next = params.get("next") || "/";
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const u = await login(email.trim(), password.trim());
            toast.success("Welcome back");
            nav(u.role === "admin" ? "/admin" : next);
        } catch (e) { toast.error(e.response?.data?.detail || "Login failed"); }
        finally { setLoading(false); }
    };

    return (
        <div className="max-w-[440px] mx-auto px-4 py-16" data-testid="login-page">
            <div className="font-mono text-[10px] uppercase text-neutral-500">Login</div>
            <h1 className="font-display text-5xl tracking-tighter mt-1">Welcome back.</h1>
            <form onSubmit={submit} className="mt-8 space-y-4">
                <label className="block">
                    <div className="font-mono text-[10px] uppercase text-neutral-500 mb-1">Email</div>
                    <input required type="email" autoComplete="email" autoCapitalize="none" autoCorrect="off" spellCheck="false" value={email} onChange={e => setEmail(e.target.value)} className="w-full border-2 border-black p-3 font-mono" data-testid="login-email" />
                </label>
                <label className="block">
                    <div className="font-mono text-[10px] uppercase text-neutral-500 mb-1">Password</div>
                    <input required type="password" autoComplete="current-password" autoCapitalize="none" autoCorrect="off" spellCheck="false" value={password} onChange={e => setPassword(e.target.value)} className="w-full border-2 border-black p-3 font-mono" data-testid="login-password" />
                </label>
                <button disabled={loading} type="submit" className="w-full bg-black text-white py-3 font-mono uppercase text-xs tracking-widest brutal-shadow" data-testid="login-submit">{loading ? "…" : "Login"}</button>
            </form>
            <div className="mt-4 font-mono text-xs">No account? <Link to="/signup" className="underline" data-testid="go-signup">Sign up →</Link></div>
        </div>
    );
}
